import React from 'react';
import Styled from 'styled';
import { observer } from 'mobx-react';
import Localizable from 'lib/intl/localizable';
import BoxView from '../box-view';

import defaultStyles from './icon-box-view.scss';

export default Styled(defaultStyles)(
    Localizable()(
        observer(function IconBoxView(props) {
            const { styles, icon, children, ...rest } = props;

            return (
                <BoxView {...rest} styles={styles}>
                    <span className={styles.icon}>{icon}</span>
                    {children}
                </BoxView>
            );
        })
    )
);
